<div
    class="card"
    role="region"
    [attr.aria-labelledby]="'profileHierarchy' + which"
    *ngIf="user"
>
    <div
        class="card-header"
        [id]="'profileHierarchy' + which"
        role="heading"
        aria-level="2"
    >
        {{ header }}
    </div>
    <div class="card-body">
        <cmps-wait-status *ngIf="hasPendingData"></cmps-wait-status>
        <div
            class="h6 text-center"
            *ngIf="!hasPendingData && (!user[which] || !user[which].length)"
        >
            {{ i18n._78_NO__LABEL_S_CONFIGURED | translate: { label: header } }}
        </div>
        <div
            class="table-responsive"
            *ngIf="!hasPendingData && user[which] && user[which].length"
        >
            <table
                class="table table-sm table-bordered-no-cells"
                [attr.aria-labelledby]="'profileHierarchy' + which"
            >
                <thead>
                    <tr>
                        <th>{{ i18n._53_NAME | translate }}</th>
                        <th>{{ i18n._75_START_DATE | translate }}</th>
                        <th>{{ i18n._73_END_DATE | translate }}</th>
                        <th>{{ i18n._77_HIERARCHY_TYPE | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let i of user[which]">
                        <td>{{ i.managerName }}</td>
                        <td>{{ i.startDate | date: 'y-MM-dd' }}</td>
                        <td>{{ i.endDate | date: 'y-MM-dd' }}</td>
                        <td>
                            {{
                                i.hierarchyTypeId
                                    | cmpsSelectLabel
                                        : hierarchyTypeOpts
                                        : 'value'
                                        : 'label'
                            }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
